export const PieShadow = () => (
  <div
    className={`
      absolute
      top-0
      right-0
      bottom-0
      left-0
      oveflow-hidden
      bg-center
      z-10
    `}
    style={{ backgroundImage: `url('/shadow.svg')` }}
  />
);
